import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 门禁
 */
const doorControl = {

  /**
   * 查询
   */
  getDoorControlRecords (measureId, pointCode, pointNumber, startTime, endTime, limit, sort) {
    return axios.post(base.doorControl.getDoorControlRecords, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, startTime, endTime, limit, sort }))
  },
  /**
   * 查询
   */
  getDoorControlRecords2 (measureId, expressionName, startTime, endTime, limit, sort) {
    return axios.post(base.doorControl.getDoorControlRecords2, utils.postParamsArrayToJsonString({ measureId, expressionName, startTime, endTime, limit, sort }))
  },
}

export default doorControl